import React, { useEffect, useState } from 'react';
import productImg from '../../../images/product-image.jpg';
import mapImg from '../../../images/map-left.jpg';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';
import { DATE_FORMAT } from '../../../_common/constant';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { showDate } from '../../../_common/functions';
import { MAP_KEY } from '../../../_config';
import Currency from '../../../components/currency';
const General: React.FC = () => {
    const params: any = useParams();
    const facilityApi: any = useFacilitiesApi();
    const [rowData, setrowData] = useState<any>(null)
    const defaultLatitude = 40.712776; // Example default latitude (New York)
    const defaultLongitude = -74.005974; // Example default longitude (New York)

    const getfacilitylist = (facilityID: any) => {
        const payload = {
            facilityID: facilityID
        }
        facilityApi.getFacilityDetails(payload, (data: any) => {
            setrowData(data ? data : []);
        }, (error: any) => { });
    };

    useEffect(() => {
        if (params.id) {
            getfacilitylist(params.id);
        }
    }, [params]);
    return (
        <div className={`flex`}>
            <div className='flex-grow border-r border-gray-200 pt-4'>
                <div className='grid grid-cols-1 gap-6'>
                    <div>
                        <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>facility Information</h4>
                        <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>facility ID</div></div>
                            <div className='w-3/4 text-[#323233]'>

                                {rowData?.facilityCode ? rowData?.facilityCode : '-'}
                            </div>
                        </div>
                        <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Facility Name</div> </div>
                            <div className='w-3/4 text-[#323233]'>

                                {rowData?.facilityName ? rowData?.facilityName : '-'}
                            </div>
                        </div>
                        <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Processing Facility Name</div> </div>
                            <div className='w-3/4 text-[#323233]'>
                                {rowData?.processingFacilityName ? rowData?.processingFacilityName : '-'}
                            </div>
                        </div>
                        <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
                            {/* Area */}
                            <div className='w-1/2 flex flex-row pr-4'>
                                <div className='w-[12.5rem] text-[#767676] mr-2'>Area</div>
                                <div className='text-[#323233]'>
                                    {rowData?.area ? `${rowData.area} sqft` : '-'}
                                </div>
                            </div>

                            {/* Ranch No */}
                            <div className='w-1/2 flex flex-row pl-4'>
                                <div className='w-[12.5rem] text-[#767676] mr-2'>Ranch No</div>
                                <div className='text-[#323233]'>
                                    {rowData?.noOfRanches ? rowData?.noOfRanches : '-'}
                                </div>
                            </div>
                        </div>
                        <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Sage Facility</div> </div>
                            <div className='w-3/4 text-[#323233]'>
                                {rowData?.sageFacilityName ? rowData?.sageFacilityName : '-'}
                            </div>
                        </div>
                        <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676]'>
                                <div className='mr-2'>Facility Manager</div>
                            </div>
                            <div className='w-3/4 text-[#323233]'>
                                {rowData?.facilityManagerList && rowData.facilityManagerList.length > 0
                                    ? rowData.facilityManagerList.map((m: any) => m.userName).join(', ')
                                    : '-'}
                            </div>
                        </div>
                        <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676]'>
                                <div className='mr-2'>Service Tech</div>
                            </div>
                            <div className='w-3/4 text-[#323233]'>
                                {rowData?.facilityServiceTechList && rowData.facilityServiceTechList.length > 0
                                    ? rowData.facilityServiceTechList.map((s: any) => s.serviceTechName).join(', ')
                                    : '-'}
                            </div>
                        </div>
                        <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676]'>
                                <div className='mr-2'>Grower List</div>
                            </div>
                            <div className='w-3/4 text-[#323233]'>
                                {rowData?.facilityTeamList && rowData.facilityTeamList.length > 0
                                    ? rowData.facilityTeamList.map((s: any) => s.teamName).join(', ')
                                    : '-'}
                            </div>
                        </div>
                    </div>
                    <div>
                        <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>Utility Providers</h4>
                        <div className="py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                            {/* Electricity */}
                            <div className="w-1/2 flex flex-row pr-4">
                                <div className="w-[12.5rem] text-[#767676] mr-2">Electricity</div>
                                <div className="text-[#323233]">
                                    {rowData?.electricityVendorServiceTypeName
                                        ? rowData?.electricityVendorServiceTypeName
                                        : '-'}
                                </div>
                            </div>

                            {/* Nat Gas */}
                            <div className="w-1/2 flex flex-row pl-4">
                                <div className="w-[12.5rem] text-[#767676] mr-2">Nat Gas</div>
                                <div className="text-[#323233]">
                                    {rowData?.natGasVendorServiceTypeName
                                        ? rowData?.natGasVendorServiceTypeName
                                        : '-'}
                                </div>
                            </div>
                        </div>
                        <div className="py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
                            {/* Water Authority */}
                            <div className="w-1/2 flex flex-row pr-4">
                                <div className="w-[12.5rem] text-[#767676] mr-2">Water Authority</div>
                                <div className="text-[#323233]">
                                    {rowData?.waterAuthrityVendorServiceTypeName
                                        ? rowData?.waterAuthrityVendorServiceTypeName
                                        : '-'}
                                </div>
                            </div>

                            {/* ISP / Telephone */}
                            <div className="w-1/2 flex flex-row pl-4">
                                <div className="w-[12.5rem] text-[#767676] mr-2">ISP / Telephone</div>
                                <div className="text-[#323233]">
                                    {rowData?.isP_TelephoneVendorServiceTypeName
                                        ? rowData?.isP_TelephoneVendorServiceTypeName
                                        : '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {rowData?.fullFilePath != null && <div className='grid grid-cols-1 gap-6 mt-6'>
                    <div>
                        <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>Uploaded Document</h4>
                        <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Tax Map Image</div></div>
                            <div className='w-[12.5rem] text-[#323233]'>
                                <div
                                    key={rowData?.renamedFileName}
                                    className="border border-primary rounded-md flex px-2 py-2 text-[0.813rem] relative"
                                >
                                    <Link to={rowData?.fullFilePath} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={rowData?.fullFilePath}
                                            alt={rowData?.originalFileName || "file"}
                                            className="h-28 w-auto object-contain rounded-md cursor-pointer hover:scale-105 transition-transform duration-300"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
            <div className='w-[19.5rem] p-[1.125rem] flex-grow-0 flex-shrink-0 '>
                <div className='max-w-[17.125rem] m-auto sticky top-[18px]'>
                    <img className='border border-gray-200 rounded-md' src={rowData?.imageFullPath} alt="" />
                    <h4 className='font-semibold text-[0.938rem] pt-5 pb-2'>Location</h4>
                    <p className='text-[0.938rem] text-[#323233]'>{rowData?.addressLine1 ? rowData?.addressLine1 : '-'} </p>
                    {/* <img className='mt-2' src={mapImg} alt="" /> */}

                    {/* <LoadScript googleMapsApiKey={MAP_KEY}>

                        <GoogleMap
                            mapContainerStyle={{
                                width: '100%',
                                height: '200px',
                            }}
                            center={{ lat: rowData?.latitude ?? defaultLatitude, lng: rowData?.longitude ?? defaultLongitude }}
                            zoom={15}
                            mapTypeId="satellite"
                        >

                            <Marker position={{ lat: rowData?.latitude ?? defaultLatitude, lng: rowData?.longitude ?? defaultLongitude }} />
                        </GoogleMap>


                    </LoadScript> */}
                    <iframe width="100%" height="250"
                        style={{
                            border: 0
                        }} src={`https://maps.google.com/maps?width=100%&height=250&hl=en&coord=${rowData?.latitude ?? defaultLatitude}, ${rowData?.longitude ?? defaultLongitude}&q=${rowData?.latitude ?? defaultLatitude}, ${rowData?.longitude ?? defaultLongitude}&ie=UTF8&t=&z=14&iwloc=B&output=embed&t=k`}>
                    </iframe>
                    <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
                        <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Added Date </div> </div>
                        <div className='w-3/4 text-[#323233]'>{rowData?.addedDate ? showDate(rowData?.addedDate) : '-'}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default General;